// The "this person's data was erased" refusal (Session ASQ, Stream G, Item 3). When the office erases a person on the
// Personal data requests page, a one-way record of their email address is kept, and the platform then refuses to bring
// them back without a warning: a new customer (POST /api/customers) or an Apollo enrichment answers 409
// { error: "erased_person", message, ... }. Every screen that can meet it reads it through this one helper and offers an
// explicit "... anyway" that resends with the server's own flag (createAnyway / importAnyway), which the server audits.
import { ApiError } from "./api";

export interface ErasedPersonRefusal {
  /** The server's own plain-English sentence, naming the address and the date. */
  message: string;
}

/** The erased-person refusal inside an error, or null when the error is anything else. */
export function erasedPersonRefusal(err: unknown): ErasedPersonRefusal | null {
  if (!(err instanceof ApiError) || err.status !== 409) return null;
  const body = err.body;
  if (!body || body.error !== "erased_person") return null;
  const message = typeof body.message === "string" && body.message.trim() ? body.message : err.code;
  return { message };
}
